/* UDF reveal-on-scroll — dependency-free, once-per-element.
   Mirrors the portfolio site: opacity 0→1, translateY(28px)→0,
   .8s cubic-bezier(.2,.6,.2,1). Skips entirely for reduced-motion
   users and inside the Shopify theme editor. */
(function () {
  'use strict';

  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.Shopify && window.Shopify.designMode) return;
  if (!('IntersectionObserver' in window)) return;

  var SELECTORS = [
    '.card--product',
    '.section-header',
    '.footer .footer-block',
    '.footer .grid > *',
    '.udf-hero__inner',
    '.udf-feature-band__card',
    '.shopify-section .rte'
  ].join(',');

  function init() {
    var els = Array.prototype.slice.call(document.querySelectorAll(SELECTORS));
    var vh = window.innerHeight;
    var watch = [];

    els.forEach(function (el) {
      if (el.classList.contains('udf-revealed') || el.classList.contains('udf-pre-reveal')) return;
      var r = el.getBoundingClientRect();
      // only hide elements below the fold — never blank what's already visible
      if (r.top > vh * 0.92) {
        el.classList.add('udf-pre-reveal');
        watch.push(el);
      }
    });

    if (!watch.length) return;

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('udf-revealed');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });

    watch.forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
